export default "__VITE_ASSET__e6619f23__"